import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { LocationsService } from 'src/app/core/services/locations/locations.service';

@Component({
  selector: 'app-country-render',
  templateUrl: './country-render.component.html',
  styleUrls: ['./country-render.component.scss']
})
export class CountryRenderComponent implements ICellRendererAngularComp {

  public params: any;
  public countries :any;
  public country : any;

  constructor(private locations : LocationsService) { }

  agInit(params: any): void {
    this.params = params;
    
    if(["nationality", "primary_covered_region", "region"].includes(params.colDef.field)){
      this.countries = params.values;
      this.setCountry(params.value);
    }
    else if (["primary_covered_city", "city"].includes(params.colDef.field)) {
      this.getCities(params);
    }    
  }

  setCountry(value){
    const valueId = (value && typeof value === 'object') ? (value.id || value.pk) : value;
    
    this.countries.forEach(country => {
      if (country.pk == valueId)
        this.country = country.name;
    });
  }

  refresh(params: any): boolean {

    ["primary_covered_city", "city"].includes(params.colDef.field) ? this.getCities(params) : this.setCountry(params.value);
    
    return true;
  }

  getCities(params) {
    let region_id = params.colDef.field === "primary_covered_city" ? params.data.primary_covered_region?.id : params.data.region;
    
    this.locations.getCoveredCities(region_id).subscribe(data =>{
      this.countries = data ;
      this.setCountry(params.value);
    })
  }
}
